import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="modal"
export default class extends Controller {
  static targets = ["backdrop", "dialog", "form"];
  clickCount = 0;
  clickTimer = null;

  connect() {
    document.addEventListener("turbo:before-cache", this.close.bind(this));
    this.element.addEventListener("modal:open", this.open.bind(this));
  }

  open_secretly(event) {
    this.clickCount++;
    if (this.clickTimer) {
      clearTimeout(this.clickTimer);
    }

    this.clickTimer = setTimeout(() => {
      this.clickCount = 0;
    }, 1500);

    if (this.clickCount >= 2) {
      this.open();
      this.clickCount = 0;
      clearTimeout(this.clickTimer);
      this.clickTimer = null;
    }
  }

  open(event) {
    const id = event?.currentTarget?.dataset?.enrollmentId;

    if (id) {
      this.formTarget.action = `/admin/enrollments/${id}`;
    }

    this.element.classList.remove("hidden");
    this.enter(this.backdropTarget);
    this.enter(this.dialogTarget);
  }

  openNestedModal(event) {
    const nestedModalId = event.target.dataset.nestedModalId;
    if (!nestedModalId) return;

    this.close();
    const nestedModal = document.getElementById(nestedModalId);
    if (nestedModal) {
      nestedModal.dispatchEvent(new CustomEvent("modal:open"));
    }
  }

  close() {
    Promise.all([
      this.leave(this.backdropTarget),
      this.leave(this.dialogTarget),
    ]).then(() => {
      this.element.classList.add("hidden");
      this.emitModalCloseEvent();
    });
  }

  escClose(event) {
    if (event.keyCode == 27) this.close();
  }

  emitModalCloseEvent() {
    this.element.dispatchEvent(new CustomEvent("modal:close"));
  }

  enter(element, transitionName = null) {
    element.classList.remove("hidden");
    this.transition("enter", element, transitionName);
  }

  leave(element, transitionName = null) {
    this.transition("leave", element, transitionName);
    element.classList.add("hidden");
  }

  async transition(direction, element, animation) {
    const dataset = element.dataset;
    const animationClass = animation ? `${animation}-${direction}` : direction;
    const transition = `transition${direction.charAt(0).toUpperCase() + direction.slice(1)}`;
    const genesis = dataset[transition]
      ? dataset[transition].split(" ")
      : [animationClass];
    const start = dataset[`${transition}Start`]
      ? dataset[`${transition}Start`].split(" ")
      : [`${animationClass}-start`];
    const end = dataset[`${transition}End`]
      ? dataset[`${transition}End`].split(" ")
      : [`${animationClass}-end`];

    this.addClasses(element, genesis);
    this.addClasses(element, start);
    await this.nextFrame();
    this.removeClasses(element, start);
    this.addClasses(element, end);
    await this.afterTransition(element);
    this.removeClasses(element, end);
    this.removeClasses(element, genesis);
  }

  addClasses(element, classes) {
    element.classList.add(...classes);
  }

  removeClasses(element, classes) {
    element.classList.remove(...classes);
  }

  nextFrame() {
    return new Promise((resolve) => {
      requestAnimationFrame(() => {
        requestAnimationFrame(resolve);
      });
    });
  }

  afterTransition(element) {
    return new Promise((resolve) => {
      // safari return string with comma separate values
      const computedDuration =
        getComputedStyle(element).transitionDuration.split(",")[0];
      const duration = Number(computedDuration.replace("s", "")) * 1000;
      setTimeout(() => {
        resolve();
      }, duration);
    });
  }
}
